import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frCommon from "./locales/fr/common.json";
import frCatalog from "./locales/fr/catalog.json";
import frCheckout from "./locales/fr/checkout.json";
import frAccount from "./locales/fr/account.json";
import frPayments from "./locales/fr/payments.json";
import frCod from "./locales/fr/cod.json";
import frWhatsapp from "./locales/fr/whatsapp.json";
import frInvoicing from "./locales/fr/invoicing.json";
import frAdmin from "./locales/fr/admin.json";
import frLogistics from "./locales/fr/logistics.json";
import frReturns from "./locales/fr/returns.json";
import frFinance from "./locales/fr/finance.json";
import frCrm from "./locales/fr/crm.json";
import frNotifications from "./locales/fr/notifications.json";
import frIntegrations from "./locales/fr/integrations.json";
import frLegal from "./locales/fr/legal.json";

import woCommon from "./locales/wo/common.json";
import woCatalog from "./locales/wo/catalog.json";
import woCheckout from "./locales/wo/checkout.json";
import woAccount from "./locales/wo/account.json";
import woPayments from "./locales/wo/payments.json";
import woCod from "./locales/wo/cod.json";
import woWhatsapp from "./locales/wo/whatsapp.json";
import woInvoicing from "./locales/wo/invoicing.json";
import woAdmin from "./locales/wo/admin.json";
import woLogistics from "./locales/wo/logistics.json";
import woReturns from "./locales/wo/returns.json";
import woFinance from "./locales/wo/finance.json";
import woCrm from "./locales/wo/crm.json";
import woNotifications from "./locales/wo/notifications.json";
import woIntegrations from "./locales/wo/integrations.json";
import woLegal from "./locales/wo/legal.json";

import enCommon from "./locales/en/common.json";
import enCatalog from "./locales/en/catalog.json";
import enCheckout from "./locales/en/checkout.json";
import enAccount from "./locales/en/account.json";
import enPayments from "./locales/en/payments.json";
import enCod from "./locales/en/cod.json";
import enWhatsapp from "./locales/en/whatsapp.json";
import enInvoicing from "./locales/en/invoicing.json";
import enAdmin from "./locales/en/admin.json";
import enLogistics from "./locales/en/logistics.json";
import enReturns from "./locales/en/returns.json";
import enFinance from "./locales/en/finance.json";
import enCrm from "./locales/en/crm.json";
import enNotifications from "./locales/en/notifications.json";
import enIntegrations from "./locales/en/integrations.json";
import enLegal from "./locales/en/legal.json";

const resources = {
  fr: {
    common: frCommon,
    catalog: frCatalog,
    checkout: frCheckout,
    account: frAccount,
    payments: frPayments,
    cod: frCod,
    whatsapp: frWhatsapp,
    invoicing: frInvoicing,
    admin: frAdmin,
    logistics: frLogistics,
    returns: frReturns,
    finance: frFinance,
    crm: frCrm,
    notifications: frNotifications,
    integrations: frIntegrations,
    legal: frLegal,
  },
  wo: {
    common: woCommon,
    catalog: woCatalog,
    checkout: woCheckout,
    account: woAccount,
    payments: woPayments,
    cod: woCod,
    whatsapp: woWhatsapp,
    invoicing: woInvoicing,
    admin: woAdmin,
    logistics: woLogistics,
    returns: woReturns,
    finance: woFinance,
    crm: woCrm,
    notifications: woNotifications,
    integrations: woIntegrations,
    legal: woLegal,
  },
  en: {
    common: enCommon,
    catalog: enCatalog,
    checkout: enCheckout,
    account: enAccount,
    payments: enPayments,
    cod: enCod,
    whatsapp: enWhatsapp,
    invoicing: enInvoicing,
    admin: enAdmin,
    logistics: enLogistics,
    returns: enReturns,
    finance: enFinance,
    crm: enCrm,
    notifications: enNotifications,
    integrations: enIntegrations,
    legal: enLegal,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("djayma-lang") || "fr",
    fallbackLng: "fr",
    defaultNS: "common",
    ns: [
      "common",
      "catalog",
      "checkout",
      "account",
      "payments",
      "cod",
      "whatsapp",
      "invoicing",
      "admin",
      "logistics",
      "returns",
      "finance",
      "crm",
      "notifications",
      "integrations",
      "legal",
    ],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "djayma-lang",
      caches: ["localStorage"],
    },
  });

// Sync <html lang> with i18next so screen readers, SEO, and browser
// behaviour match the displayed language. Kept in sync on every
// language change by listening to i18next's languageChanged event.
if (typeof document !== "undefined") {
  const applyLang = (lang: string) => {
    // Use a 2-letter code; "wo" is the ISO-639-1 code for Wolof.
    const normalized = lang.split("-")[0] || "fr";
    document.documentElement.lang = normalized;
  };
  applyLang(i18n.language);
  i18n.on("languageChanged", applyLang);
}

export default i18n;
